// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E_v9","right":"styles_right__3MT6N"};